module.exports = __webpack_public_path__ + "static/media/perfil_bruna.425d5be8.png";